export enum UpdatePasswordSuccess {
  SUCCESS = 200,
}

export enum UpdatePasswordError {
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  RECIPIENT_NOT_FOUND = 404,
  INSUFFICIENT_BALANCE = 500,
}
export const UpdatePasswordSuccessDefined = {
  [UpdatePasswordSuccess.SUCCESS]: {
    message: 'Cập nhật mật khẩu thành công',
  },
};

export const UpdatePasswordDefined = {
  [UpdatePasswordError.UNAUTHORIZED]: {
    message: 'Tài khoản không có quyền truy cập',
  },
  [UpdatePasswordError.FORBIDDEN]: {
    message: 'Tài khoản không có quyền truy cập',
  },
  [UpdatePasswordError.RECIPIENT_NOT_FOUND]: {
    message: `Không tìm thấy người dùng, Không thể lấy thông tin người nhận`,
  },
  [UpdatePasswordError.INSUFFICIENT_BALANCE]: {
    message: 'Đã có lỗi xảy ra, vui lòng thử lại sau',
  },
};
